import styled from 'styled-components';
import { media, mediaQuery } from '../../../common/styles/styleUtil';

export const PropertyOptionWrapper = styled.div`
  padding-top: 32px;
  border-top: 1px solid #d2d6da;
  @media (${mediaQuery.tablet}) {
    padding: 32px 24px 0;
  }
  ${media.xs`
    padding: 32px 16px 0;
  `}
`;

export const PropertyOptionTitle = styled.h2`
  color: #333f48;
  font-size: 18px;
  font-weight: bold;
  line-height: normal;
  letter-spacing: normal;
`;

export const PropertyOptionContentWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #d2d6da;
  ${media.xs`
    display: block;
  `}
`;

export const PropertyOptionImage = styled.div<{ noImage: boolean }>`
  width: 260px;
  height: 160px;
  background: #f3f4f6;
  ${media.xs`
    width: 343px;
    height: 212px;
  `}
  .lazy-image-wrapper {
    height: 100%;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: ${(props) => (props.noImage ? 'contain' : 'cover')};
  }
  .no-image {
    width: 100%;
    height: 100%;
    svg {
      width: 100%;
      height: 100%;
    }
  }
`;

export const PropertyOptionInfo = styled.div`
  width: 65%;
  padding: 0 32px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  ${media.xs`
    width: 100%;
    padding: 16px 0 0;
  `}
`;

export const PropertyTitleWrapper = styled.div`
  width: 100%;
  margin-bottom: 16px;
`;

export const PropertyTitle = styled.h3`
  margin: 0 0 4px;
  font-size: 18px;
  font-weight: 300;
  line-height: 1.22;
  letter-spacing: normal;
  color: #333f48;
`;

export const PropertyPrice = styled(PropertyTitle)`
  font-size: 14px;
  font-weight: 500;
  line-height: 1.43;
`;

export const PropertyOptionAttributeWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const PropertyOptionAttribute = styled.div`
  width: 50%;
  margin-bottom: 16px;
  font-size: 14px;
  &:nth-child(1n + 3) {
    margin-bottom: 0;
  }
`;

export const PropertyOptionAttributeTitle = styled.div`
  font-weight: 300;
  color: #697684;
`;

export const PropertyOptionAttributeData = styled.div`
  font-weight: 500;
  color: #333f48;
`;

export const PropertyOptionConfigWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
`;

export const PropertyOptionConfig = styled.div`
  margin-right: 12px;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.43;
  letter-spacing: normal;
  color: #333f48;
`;
